import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { ServicesContext } from 'services/context'
import { spec, validators } from 'utils/validation'

import { toOptions } from 'routes/public/events/overview/components/filters/helpers'
import i18next from 'i18next'
import EditAthletesFormComponent from './component'
import { createFormatSportFunction } from './helpers'
import { toAthleteModel } from './mapping'

const { any } = validators

export const EditAthletesForm = combine(
  withContext(
    'adminAthletesService',
    ServicesContext,
    ({ adminAthletesService }) => adminAthletesService
  ),

  withFormModel(
    (_state, { initialValues }) => {
      return {
        dateOfBirth: {
          initialValue: initialValues.dateOfBirth || '',
          spec: spec.flow(any.required),
        },

        name: {
          initialValue: initialValues.name || '',
          spec: spec.flow(any.required),
        },

        surname: {
          initialValue: initialValues.surname || '',
          spec: spec.flow(any.required),
        },

        nationality: {
          initialValue: initialValues.nationality || '',
          spec: spec.flow(any.required),
        },

        sport: {
          initialValue: createFormatSportFunction(initialValues.sport) || '',
          spec: spec.flow(any.required),
        },

        logo: {
          initialValue:
            initialValues.logo || 'football/nz/player/defaultavatar.png',
          spec: spec.flow(any.required),
        },
        id: {
          initialValue: initialValues.id || '',
          spec: spec.flow(any.required),
        },
      }
    },
    { id: 'athlete-edit-form' }
  ),

  withCallbacks(
    {
      loadCategories: () => async () => {
        const sportTypes = toOptions(
          i18next.t('enum:sportType', { returnObjects: true })
        )
        return sportTypes
      },
      onSubmitRequest: {
        deps: ['onSubmit'],
        func:
          (_state, { onSubmit }) =>
          (form) => {
            return onSubmit(toAthleteModel(form))
          },
      },
    },
    []
  )
)(EditAthletesFormComponent)
